var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5781 12.5C17.5781 13.3629 18.2777 14.0625 19.1406 14.0625C20.0036 14.0625 20.7031 13.3629 20.7031 12.5C20.7031 11.6371 20.0036 10.9375 19.1406 10.9375C18.2777 10.9375 17.5781 11.6371 17.5781 12.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 12.5C12.9375 13.3629 13.6371 14.0625 14.5 14.0625C15.3629 14.0625 16.0625 13.3629 16.0625 12.5C16.0625 11.6371 15.3629 10.9375 14.5 10.9375C13.6371 10.9375 12.9375 11.6371 12.9375 12.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29687 12.5C8.29687 13.3629 8.99643 14.0625 9.85937 14.0625C10.7223 14.0625 11.4219 13.3629 11.4219 12.5C11.4219 11.6371 10.7223 10.9375 9.85938 10.9375C8.99643 10.9375 8.29687 11.6371 8.29687 12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsSmall);
export default __webpack_public_path__ + "static/media/DotsSmall.eeb9bc8fd19e6078b2261ad117eb4c61.svg";
export { ForwardRef as ReactComponent };